// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2a-U2","ranges":"BmiRanges_ranges__1bqoX"};